import { Account } from '@modules-deprecated/app/accounts/types'

const SHINE = 'shine'
const KONTIST = 'kontist'

const PARTNER_BANK_NAMES: readonly string[] = [SHINE, KONTIST]

export const isShineAccount = (account: Account): boolean => {
  return account.name?.toLowerCase().trim() === SHINE
}

export const isKontistAccount = (account: Account): boolean => {
  return account.name?.toLowerCase().trim() === KONTIST
}

export const isPartnerAccount = (account: Account): boolean => {
  const accountName = account.name?.toLowerCase().trim()
  return PARTNER_BANK_NAMES.includes(accountName)
}
